export default function searchPanel({main, on, elm}) {
	const dialog = elm.querySelector('dialog');
	const opener = document.querySelector('[data-dialog="search-panel"]');

	main(() => {
		on('click', 'dialog', backdropClickHandle);

		opener?.addEventListener('click', openDialogHandle);
		dialog.addEventListener('close', closeDialogHandle);
	});

	const openDialogHandle = function() {
		window.setTimeout(() => {
			elm.querySelector('search-box')?.focusSearch?.();
		}, 0);
	};

	const closeDialogHandle = function() {
		elm.querySelector('search-box')?.resetSearch?.();
	};

	const backdropClickHandle = function(e) {
		const dialogDimensions = dialog.getBoundingClientRect();

		if (
			e.clientX < dialogDimensions.left ||
			e.clientX > dialogDimensions.right ||
			e.clientY < dialogDimensions.top ||
			e.clientY > dialogDimensions.bottom
		) {
			dialog.close();
		}
	};
}

export const model = {};
